import {withAppContext} from "../util/withAppContext";
import EnlilDetail from "./EnlilDetail";
import React from "react";
import {Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography} from "@mui/material";
import spinner from "../assets/Spinner-1s-200px.svg";
import CCButton from "./Common/CCButton";
import css_buttons from "./Common/css/CCButton.module.scss";


class EnlilDetailDialog extends EnlilDetail {

    renderExtension() {
        let buttonHandler = null;
        let objectDetailContent = null;

        if (this.state.fetchBackgroundOperation === false && this.state.controls !== null && this.state.insertBackgroundOperation === false && this.state.updateBackgroundOperation === false) {
            let content = [];

            let groups = this.getGroups();
            for (let i = 0; i < groups.length; i++) {
                let group = groups[i];

                if (group["type"] === "standard") {
                    content.push(this.renderStandardGroup(group));
                } else if (group["type"] === "checkbox") {
                    content.push(this.renderCheckboxGroup(group));
                }
            }

            let initialModificationWarning = null;
            if (this.state.showInitialModificationWarning === true) {
                initialModificationWarning = (
                    <Grid key="warning" item container spacing={2}>
                        <Typography style={{fontSize: "13px", color: "#E74C3C", marginLeft: "5px", marginTop: "20px"}}>No changes made.</Typography>
                    </Grid>
                );
            }

            if (this.state.insertBackgroundOperation) {}  // force a new render whenever insertBackgroundOperation changes

            objectDetailContent = (
                <React.Fragment>
                    <Grid key="id7" container justifyContent="center" columnSpacing={2}>
                        {content}
                    </Grid>
                    {initialModificationWarning}
                </React.Fragment>
            );

            let firstButtonHandlerContent;
            if (this.state.showConfirmation) {
                firstButtonHandlerContent = (
                    <CCButton
                        className={css_buttons.redStandardButton}
                        onClick={this.cancel2Handler}>
                        Don't Save
                    </CCButton>
                );
            } else if (this.state.action === "Save Completed") {
                firstButtonHandlerContent = (
                    <CCButton
                        className={css_buttons.blueStandardButton}
                        onClick={this.cancel2Handler}>
                        Done
                    </CCButton>
                );
            } else {
                firstButtonHandlerContent = (
                    <CCButton
                        className={css_buttons.redStandardButton}
                        onClick={this.cancel1Handler}>
                        Cancel
                    </CCButton>
                );
            }
            let secondButtonHandlerContent;
            if (this.state.action === "New" || this.state.action === "Edit") {
                secondButtonHandlerContent = (
                    <>
                        {this.props.saveAndNewAction && (
                            <CCButton
                                className={css_buttons.redStandardButton}
                                disabled={this.evaluateSaveDisabledStatus()}
                                animate={this.state.deleteBackgroundOperation === true}
                                onClick={this.saveAndOpenNewHandler}>
                                {this.state.action === "New" ? "+ Add Another" : "+ Add New"}
                            </CCButton>
                        )}
                        <CCButton
                            className={css_buttons.blueStandardButton}
                            disabled={this.evaluateSaveDisabledStatus()}
                            animate={this.state.updateBackgroundOperation === true || this.state.insertBackgroundOperation === true}
                            onClick={() => this.saveHandler()}>
                            {this.state.performConfirmOnSave ? "Confirm" : "Save"}
                        </CCButton>
                    </>
                );
            } else if (this.state.action === "Query") {
                secondButtonHandlerContent = (
                    <>
                        <CCButton
                            className={css_buttons.blueStandardButton}
                            disabled={this.evaluateSaveDisabledStatus()}
                            animate={this.state.queryBackgroundOperation === true}
                            onClick={() => this.searchHandler()}>
                            Search
                        </CCButton>
                    </>
                );
            } else if (this.state.action === "Delete") {
                secondButtonHandlerContent = (
                    <>
                        <CCButton
                            className={css_buttons.blueStandardButton}
                            disabled={this.evaluateSaveDisabledStatus()}
                            animate={this.state.deleteBackgroundOperation === true}
                            onClick={() => this.saveHandler()}>
                            Delete
                        </CCButton>
                    </>
                );
            }

            buttonHandler = (
                <DialogActions style={{marginBottom: "10px", width: "96%"}}>
                    {firstButtonHandlerContent}
                    {secondButtonHandlerContent}
                </DialogActions>
            );
        }

        let title;
        if (this.props.title !== null && this.props.title !== undefined) {
            if (this.state.action === "New") {
                title = "Add " + this.props.title;
            } else if (this.state.action === "Delete") {
                title = "Delete " + this.props.title;
            } else if (this.state.action === "Edit") {
                title = "Edit " + this.props.title;
            } else if (this.state.action === "Save") {
                title = "Saving... One moment please.";
            } else if (this.state.action === "Save Completed") {
                title = "Save completed.";
            } else if (this.state.action === "Query") {
                title = "Search " + this.props.title;
            } else {
                title = "View " + this.props.title;
            }
        }

        return (
            <>
                <Dialog open={true} scroll="body">
                    <DialogTitle>{title}</DialogTitle>
                    <DialogContent>
                        {objectDetailContent || (
                            <div style={{display: "flex", justifyContent: "center", marginBottom: "40px"}}>
                                <img src={spinner} alt="spinner" width={80} height={80} style={{margin: "auto"}} />
                            </div>
                        )}
                    </DialogContent>
                    {buttonHandler}
                </Dialog>
            </>
        );
    }
}

export default withAppContext(EnlilDetailDialog);